<template>
  <div>
    <ul class="heading-ul mb-10 ml-10">
      <li>
        <router-link to="/customers" class="vx-row">
          <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          <h4>{{ $t("customers.label.create_customer") }}</h4>
        </router-link>
      </li>
    </ul>
    <div class="mt-5">
      <form-wizard
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        stepSize="xs"
        shape="circle"
        ref="wizard"
      >
        <tab-content
          :title="$t('customers.label.create_customer')"
          class="mb-5"
          icon="feather icon-home"
          ><vx-card class="form-padding">
            <ValidationObserver ref="observer1">
              <!-- tab 1 content -->
              <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="vx-row">
                    <div
                      class="vx-col w-full lg:w-1/4 md:w-1/4 sm:w-full xs:w-full"
                    >
                      <upload-picture @image-selected="imageSelected"/>
                    </div>
                    <div
                      class="vx-col w-full lg:w-3/4 md:w-3/4 sm:w-full xs:w-full"
                    >
                      <div class="vx-row">
                        <div
                          class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                        >
                          <ul class="pt-3" style="align-items: center">
                            <li
                              class="vx-col lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                            >
                              <vs-radio
                                v-model="customer.radio"
                                vs-name="radios1"
                                vs-value="individual"
                                @change="radioChange"
                              >
                                {{ $t("customers.label.individual") }}</vs-radio
                              >
                            </li>
                            <li
                              class="vx-col lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                            >
                              <vs-radio
                                v-model="customer.radio"
                                vs-name="radios1"
                                vs-value="corporate"
                                @change="radioChange"
                              >
                                {{ $t("customers.label.corporate") }}</vs-radio
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="vx-col w-full lg:w-2/3 md:w-2/3 sm:w-full xs:w-full"
                        >
                          <div class="dropdown-with-label w-full">
                            <small class="date-label"
                              >{{ $t("customers.label.title") }}
                            </small>
                            <v-select
                              label="text"
                              class="custom-select-title"
                              v-model="customer.title"
                              :placeholder="$t('placeholder.label.SelectOne')"
                              :clearable="false"
                              :options="titleOptions"
                              :reduce="(text) => text.text"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <vs-input
                          v-if="this.customer.showCorporate"
                          :label="$t('customers.label.corporate_details')"
                          v-model="customer.middleName"
                          class="w-full font-semibold"
                        />
                        <vs-input
                          v-else
                          :label="$t('customers.label.middle_name')"
                          v-model="customer.middleName"
                          class="w-full font-semibold"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="corporate"
                        v-if="this.customer.showCorporate"
                      >
                        <vs-input
                          :label="$t('customers.label.corporate')"
                          v-model="customer.firstName"
                          class="w-full font-semibold mb-3 starlabel"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                      <ValidationProvider
                        rules="required|alpha"
                        v-slot="{ errors }"
                        :name="$t('customers.label.first_name')"
                        v-else
                      >
                        <vs-input
                          :label="$t('customers.label.first_name')"
                          v-model="customer.firstName"
                          class="w-full font-semibold mb-3 starlabel"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('customers.label.contact_person')"
                        v-if="this.customer.showCorporate"
                      >
                        <vs-input
                          :label="$t('customers.label.contact_person')"
                          v-model="customer.lastName"
                          class="w-full font-semibold mt-2 starlabel"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                      <ValidationProvider
                        rules="required|alpha"
                        v-slot="{ errors }"
                        :name="$t('customers.label.last_name')"
                        v-else
                      >
                        <vs-input
                          :label="$t('customers.label.last_name')"
                          v-model="customer.lastName"
                          class="w-full mb-2 font-semibold mt-2 starlabel"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.business_entity") }}
                      <span class="required">*</span></small
                    >
                    <v-select
                      label="name"
                      v-model="customer.entity"
                      :options="customer.entityList"
                      :placeholder="$t('customers.label.business_entity')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                      :reduce="(name) => name.id"
                    >
                      <template slot="option" slot-scope="option"
                        >{{ option.externalId }}--- {{ option.name }}</template
                      >
                    </v-select>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.client_category") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.client_category')"
                    >
                      <v-select
                        label="categoryType"
                        v-model="customer.categeory"
                        :options="getCustomerTemplate.clientCategoryDatas"
                        :placeholder="$t('customers.label.SelectCategory')"
                        :reduce="(categoryType) => categoryType.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.Gender") }} <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.Gender')"
                    >
                      <v-select
                        label="value"
                        v-model="customer.gender"
                        :options="getCustomerTemplate.genderDatas"
                        :placeholder="$t('customers.label.SelectGender')"
                        :reduce="(categoryType) => categoryType.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div
                  class="vx-col md:w-1/2 w-full"
                  v-if="customer.categeory == 2"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.business_name')"
                  >
                    <vs-input
                      type="text"
                      :label="$t('customers.label.business_name')"
                      v-model="customer.businessName"
                      class="w-full font-semibold starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <!-- <ValidationProvider
                    :rules="phoneRule"
                    v-slot="{ errors }"
                    name="phone number"
                  >
                    <c-tel-input
                      class="w-full font-semibold starlabel"
                      inputType="number"
                      v-model="customer.phone"
                      :required="true"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider> -->
                  <ValidationProvider
                    rules="required|max:10|numeric"
                    v-slot="{ errors }"
                    :name="$t('customers.label.phone_number')"
                  >
                    <vs-input
                      :label="$t('customers.label.phone_number')"
                      v-model="customer.phone"
                      class="w-full font-semibold starlabel mb-2"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>

                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.landline_number')"
                  >
                    <vs-input
                      :label="$t('customers.label.landline_number')"
                      v-model="customer.homePhone"
                      class="w-full font-semibold mb-3 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider
                    rules="required|email"
                    v-slot="{ errors }"
                    :name="$t('customers.label.email')"
                  >
                    <vs-input
                      type="email"
                      :label="$t('customers.label.email')"
                      v-model="customer.email"
                      class="w-full font-semibold starlabel mb-3"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full pt-3">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.preferences") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.preferences')"
                    >
                      <v-select
                        label="mCodeValue"
                        v-model="customer.preferences"
                        :options="getCustomerTemplate.preferences"
                        :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                        :placeholder="$t('customers.label.SelectPreferences')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full pt-2">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{ $t("customers.label.Date_of_Birth") }}</small>
                    <ValidationProvider
                      rules="required|min_age"
                      v-slot="{ errors }"
                      :name="$t('customers.label.Date_of_Birth')"
                      :key="resetKey"
                    >
                      <datepicker
                        :placeholder="$t('placeholder.label.SelectDate')"
                        v-model="customer.dateOfBirth"
                        class="mt-1 font-semibold"
                        :disabled-dates="{ from: new Date() }"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.Nationality") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.Nationality')"
                    >
                      <v-select
                        label="mCodeValue"
                        v-model="customer.nationalityId"
                        :options="getCustomerTemplate.nationalityDatas"
                        :reduce="(mCodeValue) => mCodeValue.id"
                        :placeholder="$t('customers.label.SelectNationality')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.id_proof") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.id_proof')"
                    >
                      <v-select
                        label="type"
                        v-model="customer.idProof"
                        :options="getCustomerTemplate.idProofs"
                        :reduce="(obj) => obj.id"
                        :placeholder="$t('customers.label.id_proof')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider
                    rules="required|max:16|alpha_num"
                    v-slot="{ errors }"
                    :name="$t('customers.label.id_proof_value')"
                  >
                    <vs-input
                      :label="$t('customers.label.id_proof_value')"
                      v-model="customer.idProofValue"
                      class="w-full font-semibold starlabel mb-2"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider
                    rules="required|digits:9"
                    v-slot="{ errors }"
                    :name="$t('customers.label.caf_id')"
                  >
                    <vs-input
                      :label="$t('customers.label.caf_id')"
                      v-model="customer.CafId"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red; margin-top:-5px">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <!-- <div class="vx-col md:w-1/2 w-full pt-1">
                  <vs-input
                    :label="$t('customers.label.parent_id')"
                    v-model="customer.customerParentId"
                    class="w-full font-semibold mb-2"
                  />
                </div> -->
                <div
                  class="vx-col md:w-1/2 w-full"
                  v-if="this.customer.showCorporate"
                >
                  <div>
                    <vs-checkbox
                      class="mt-base"
                      v-model="customer.parentCheckBox"
                      vs-value="0"
                      @click="parent = !parent"
                      >Is Parent</vs-checkbox
                    >
                  </div>
                </div>
                <div
                  class="vx-col md:w-1/2 w-full"
                  v-if="this.customer.showCorporate"
                >
                  <div class="dropdown-with-label" v-show="!parent">
                    <small class="date-label"
                      >{{ $t("accounting.label.parent") }}
                    </small>
                    <vue-simple-suggest
                      v-model="parentObj"
                      :list="parentSuggestionList"
                      @input="testMethod3()"
                      class="w-full font-normal"
                      :filter-by-query="true"
                    >
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        <span>{{ suggestion.displayName }} </span>
                      </div>
                      <!-- Filter by input text to only show the matching results -->
                    </vue-simple-suggest>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full pt-5">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{ $t("customers.label.VIP") }} </small>
                    <v-select
                      label="value"
                      v-model="customer.vipId"
                      :options="getCustomerTemplate.vipDatas"
                      :placeholder="$t('customers.label.SelectVIP')"
                      :reduce="(categoryType) => categoryType.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full pt-5">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{ $t("customers.label.Disability") }} </small>
                    <v-select
                      label="value"
                      v-model="customer.disabilityId"
                      :options="getCustomerTemplate.disabilityDatas"
                      :placeholder="$t('customers.label.SelectDisability')"
                      :reduce="(categoryType) => categoryType.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    />
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </vx-card>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content
          :title="$t('customers.label.address')"
          class="mb-5"
          icon="feather icon-briefcase"
          ><vx-card class="form-padding">
            <ValidationObserver ref="observer2">
              <h3>
                {{ $t("customers.label.serviceAddress") }}
              </h3>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.address')"
                  >
                    <vs-input
                      :label="$t('customers.label.address')"
                      v-model="customer.primary.address"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <vs-input
                    :label="$t('customers.label.village_street')"
                    v-model="customer.primary.village"
                    class="w-full font-semibold"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.city_area") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.city_area')"
                    >
                      <v-select
                        label="item"
                        v-model="customer.primary.city"
                        :options="
                          getCustomerTemplate.addressTemplateData.cityData
                        "
                        :placeholder="$t('customers.label.SelectCity')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                        @input="handlerCityPrimaryChange"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <vs-input
                    :label="$t('customers.label.District')"
                    disabled
                    v-model="customer.primary.district"
                    class="w-full font-semibold mb-2 starlabel"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                    :label="$t('customers.label.state')"
                    disabled
                    v-model="customer.primary.state"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                    :label="$t('customers.label.country')"
                    disabled
                    v-model="customer.primary.country"
                    class="w-full font-semibold mb-2 starlabel"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <ValidationProvider
                    rules="required|max:6|numeric"
                    v-slot="{ errors }"
                    :name="$t('customers.label.zipcode')"
                  >
                    <vs-input
                      :label="$t('customers.label.zipcode')"
                      v-model="customer.primary.zipCode"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="mt-5">
                <h3 class="mt-5">
                  {{ $t("customers.label.billing_address") }}
                </h3>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-checkbox
                      class="leftx flex"
                      v-model="sameAddress"
                      vs-value="0"
                      @change="checkSameAddress()"
                      >{{$t('customers.label.Is_your_billing_address_same_as_primary_address')}}</vs-checkbox
                    >
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-2">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.address')"
                    >
                      <vs-input
                        :label="$t('customers.label.address')"
                        v-model="customer.billing.address"
                        class="w-full font-semibold mb-2 starlabel"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input
                      :label="$t('customers.label.village_street')"
                      v-model="customer.billing.village"
                      class="w-full font-semibold"
                      style="margin-top: -7px"
                    />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("customers.label.city_area") }}
                        <span class="required">*</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('customers.label.city_area')"
                      >
                        <v-select
                          label="item"
                          v-model="customer.billing.city"
                          :options="
                            getCustomerTemplate.addressTemplateData.cityData
                          "
                          :placeholder="$t('customers.label.SelectCity')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full"
                          @input="handlerCityBillingChange"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-2">
                    <vs-input
                      :label="$t('customers.label.district')"
                      disabled
                      v-model="customer.billing.district"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-2">
                    <vs-input
                      :label="$t('customers.label.state')"
                      disabled
                      v-model="customer.billing.state"
                      class="w-full mb-2 font-semibold"
                    />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-2">
                    <vs-input
                      :label="$t('customers.label.country')"
                      disabled
                      v-model="customer.billing.country"
                      class="w-full font-semibold mb-2"
                    />
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-2">
                    <ValidationProvider
                      rules="required|max:6|numeric"
                      v-slot="{ errors }"
                      :name="$t('customers.label.zipcode')"
                    >
                      <vs-input
                        :label="$t('customers.label.zipcode')"
                        v-model="customer.billing.zipCode"
                        class="w-full font-semibold mb-2 starlabel"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </vx-card>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content
          :title="$t('customers.label.bill_information')"
          class="mb-5"
          icon="feather icon-book"
          ><vx-card>
            <ValidationObserver ref="observer3">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.bill_day_of_month") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.bill_day_of_month')"
                    >
                      <v-select
                        label="item"
                        v-model="customer.billInfo.billDay"
                        :options="generatedBillDayValues"
                        :placeholder="$t('customers.label.SelectBillDay')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.type") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.type')"
                    >
                      <v-select
                        label="item"
                        v-model="customer.billInfo.type"
                        :options="['postpaid', 'prepaid']"
                        :placeholder="$t('customers.label.SelectType')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-checkbox
                    class="leftx flex"
                    vs-value="0"
                    v-model="customer.billInfo.supressbill"
                    >{{$t('customers.label.Supressbill')}}</vs-checkbox
                  >
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.fiscal_year") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.fiscal_year')"
                    >
                      <v-select
                        label="name"
                        v-model="customer.billInfo.fiscalYear"
                        :reduce="(obj) => obj.id"
                        :options="fiscalYears"
                        :placeholder="$t('customers.label.SelectFiscalYear')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.fiscal_quater") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.fiscal_quater')"
                    >
                      <v-select
                        label="name"
                        v-model="customer.billInfo.fiscalQuater"
                        :reduce="(obj) => obj.id"
                        :options="fiscalQuarters"
                        :placeholder="$t('customers.label.SelectFiscalQuarter')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.bill_mode") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.bill_mode')"
                    >
                      <v-select
                        label="item"
                        v-model="customer.billInfo.billMode"
                        :options="['E-invoice', 'Paper Invoice', 'Both']"
                        :placeholder="$t('customers.label.SelectBillMode')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.invoice_type") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.invoice_type')"
                    >
                      <v-select
                        label="item"
                        v-model="customer.billInfo.invoiceType"
                        :options="['Summary', 'Detail']"
                        :placeholder="$t('customers.label.SelectInvoiceType')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </vx-card>
        </tab-content>

        <!-- <tab-content
          :title="$t('customers.label.payment_information')"
          class="mb-5"
          icon="feather icon-credit-card"
        >
          <vx-card class="form-padding">
            <ValidationObserver ref="observer4">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.payment_type") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="payment type"
                    >
                      <v-select
                        label="item"
                        v-model="paymentType"
                        :options="['credit card', 'funder', 'bank']"
                        placeholder="Select Type"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                        @input="resetPaymentTypeData"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div
                  v-if="paymentType === 'funder'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required|alpha_spaces"
                    v-slot="{ errors }"
                    name="funder name"
                  >
                    <vs-input
                      v-model="customer.payInfo.funderName"
                      :label="$t('customers.label.funder_name')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div
                  v-if="paymentType === 'funder'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="funder address"
                  >
                    <vs-input
                      v-model="customer.payInfo.address"
                      :label="$t('customers.label.funder_address')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div
                  v-if="paymentType === 'funder'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="funder id"
                  >
                    <vs-input
                      :label="$t('customers.label.funder_id')"
                      v-model="customer.payInfo.funderId"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div
                  v-if="paymentType === 'funder'"
                  class="vx-col md:w-1/2 w-full mt-5"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="po number"
                  >
                    <vs-input
                      v-model="customer.payInfo.poNumber"
                      :label="$t('customers.label.po_number')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div
                  v-if="paymentType === 'funder'"
                  class="vx-col md:w-1/2 w-full mt-5"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.payment_term") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="payment term"
                    >
                      <v-select
                        label="item"
                        v-model="customer.payInfo.paymentTerm"
                        :options="['30 days', '45 days']"
                        placeholder="Select Payment Term"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div
                  v-if="paymentType === 'credit card'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required|alpha_spaces"
                    v-slot="{ errors }"
                    name="card holder name"
                  >
                    <vs-input
                      v-model="customer.payInfo.cardHolderName"
                      :label="$t('customers.label.card_holder_name')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>

                <div
                  v-if="paymentType === 'credit card'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required|digits:16"
                    v-slot="{ errors }"
                    name="card number"
                  >
                    <vs-input
                      v-model="customer.payInfo.cardNumber"
                      :label="$t('customers.label.card_number')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>

                <div
                  v-if="paymentType === 'credit card'"
                  class="vx-col md:w-1/2 mt-2 w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.card_type")
                      }}<span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="card type"
                    >
                      <v-select
                        label="text"
                        :options="cardTypes"
                        v-model="customer.payInfo.cardType"
                        placeholder="Select Card Type"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div
                  v-if="paymentType === 'credit card'"
                  class="vx-col md:w-1/2 mt-2 w-full"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="expiry date"
                  >
                    <vs-input
                      :label="$t('customers.label.expiry_date')"
                      class="w-full mb-2 starlabel"
                      icon-no-border
                      v-model="customer.payInfo.cardExpiryDate"
                      placeholder="MM/YYYY"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div
                  v-if="paymentType === 'credit card'"
                  class="vx-col md:w-1/2 mt-2 w-full"
                >
                  <ValidationProvider
                    rules="required|digits:3"
                    v-slot="{ errors }"
                    name="cvv"
                  >
                    <vs-input
                      :label="$t('customers.label.cvv')"
                      icon-no-border
                      v-model="customer.payInfo.cvvNumber"
                      class="w-full mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>

                <div
                  v-if="paymentType === 'bank'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="account holder name"
                  >
                    <vs-input
                      v-model="customer.payInfo.accountHolderName"
                      :label="$t('customers.label.bank_account_holder_name')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div> -->
        <!-- <div
                  v-if="paymentType === 'bank'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="bank account no."
                  >
                    <vs-input
                      type="number"
                      v-model="customer.payInfo.bankAccountNumber"
                      :label="$t('customers.label.bank_account_number')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div> -->
        <!-- <div
                  v-if="paymentType === 'bank'"
                  class="vx-col md:w-1/2 w-full mt-2"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="bank name"
                  >
                    <vs-input
                      v-model="customer.payInfo.bankName"
                      :label="$t('customers.label.bank_name')"
                      class="w-full font-semibold mb-2 starlabel"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div> -->
        <!-- <div
                  v-if="paymentType === 'bank'"
                  class="vx-col md:w-1/2 w-full mt-5"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.account_type") }}
                      <span class="required">*</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="account type"
                    >
                      <v-select
                        label="item"
                        v-model="customer.payInfo.accountType"
                        :options="['Savings', 'Current']"
                        placeholder="Select Payment Term"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->
        <!-- <div
                  v-if="paymentType === 'bank'"
                  class="vx-col md:w-1/2 w-full mt-5"
                > -->
        <!-- <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="each card routing no."
                  > -->
        <!-- <vs-input
                    type="number"
                    v-model="customer.payInfo.cardRoutingNumber"
                    :label="$t('customers.label.each_card_routing_number')"
                    class="w-full font-semibold mb-2"
                  /> -->
        <!-- <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider> -->
        <!-- </div>
              </div>
            </ValidationObserver>
          </vx-card>
        </tab-content> -->
        <tab-content
          :title="$t('customers.label.done')"
          class="mb-5"
          icon="feather icon-award"
          ><vx-card class="form-padding">
            <div style="height: 20px"></div>
            <vs-row justify="center">
              <div style="margin-left: auto; margin-right: auto">
                <img
                  src="@/assets/images/pages/success.png"
                  style="width: 400px"
                />
              </div>
            </vs-row>
            <div class="center success-msg">
              {{ $t("customers.label.customer_created_successfully") }}
            </div>
            <vs-row justify="center">
              <div style="margin-left: auto; margin-right: auto">
                <vs-button
                  @click="
                    $router.push({
                      path: `/customers`,
                    })
                  "
                >
                  {{ $t("customers.label.go_to_customer") }}
                </vs-button>
              </div></vs-row
            >
          </vx-card>
        </tab-content>
        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left"></div>
          <div class="wizard-footer-right"></div>
          <div class="center">
            <vs-button
              class="footerButton-cancel"
              v-if="props.activeTabIndex == 0"
              type="border"
              @click="$router.push('/customers').catch(() => {})"
              >{{ $t("customers.label.cancel") }}</vs-button
            >
            <vs-button
              class="footerButton-cancel"
              v-if="props.activeTabIndex > 0 && !props.isLastStep"
              @click.native="props.prevTab()"
              type="border"
              >{{ $t("customers.label.previous") }}</vs-button
            >
            <vs-button
              class="footerButton-next"
              v-if="props.activeTabIndex == 0 || props.activeTabIndex == 1"
              @click.native="validate(props.activeTabIndex)"
              :style="props.fillButtonStyle"
            >
              {{
                props.isLastStep
                  ? $t("customers.label.done")
                  : $t("customers.label.next")
              }}</vs-button
            >
            <vs-button
              class="footerButton-next"
              @click.native="validate(props.activeTabIndex)"
              v-if="props.activeTabIndex === 2"
              :style="props.fillButtonStyle"
              >{{ $t("customers.label.submit") }}</vs-button
            >
          </div>
        </template>
      </form-wizard>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VueSimpleSuggest from "vue-simple-suggest";
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
import cInput from "@/components/vx-card/CustomInput";
import cTelInput from "@/components/vx-card/MobileNumberInput";
import UploadPicture from "@/components/UploadPicture.vue";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";
import { setHeader, removeHeader } from "@/http";
import Datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      imageData: {},
      // paymentType: null,
      cardTypes: [
        "MASTERCARD",
        "VISA",
        "DISCOVERY",
        "AMERICAN EXPRESS",
        "OTHERS",
      ],
      profilePicData:"",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      sameAddress: null,
      parentObj: "",
      parent: false,
      customer: {
        firstName: "",
        lastName: "",
        middleName: "",
        email: "",
        CafId: "",
        Value: "",
        idProof: "",
        title: "Mr.",
        vipId: -1,
        disabilityId: -1,
        phone: "",
        homePhone: "",
        entity: "",
        entityList: "",
        categeory: "",
        preferences: "",
        radio: "individual",
        child: "",
        parent: true,
        parentCheckBox: null,
        customerParentId: null,
        parentId: null,
        profile: "",
        primary: {
          address: "",
          district: "",
          village: "",
          state: "",
          city: "",
          country: "",
          zipCode: "",
        },
        billing: {
          address: "",
          district: "",
          village: "",
          state: "",
          city: "",
          country: "",
          zipCode: "",
        },
        billInfo: {
          billDay: null,
          type: null,
          supressbill: false,
          fiscalYear: null,
          fiscalQuater: null,
          billMode: null,
          invoiceType: null,
        },
        // payInfo: {
        //   funderName: "",
        //   address: "",
        //   funderId: "",
        //   poNumber: "",
        //   paymentTerm: null,
        //   cardHolderName: null,
        //   cardNumber: null,
        //   cardType: null,
        //   cardExpiryDate: null,
        //   cvvNumber: null,
        //   accountHolderName: null,
        //   bankAccountNumber: null,
        //   bankName: null,
        //   accountType: null,
        //   cardRoutingNumber: null,
        // },
        dateFormat: "dd MMMM yyyy",
        activationDate: moment().format("DD MMMM YYYY"),
        clientData: {},
        showCorporate: false,
      },
      titleOptions: [
        { text: "Mr.", value: "mr" },
        { text: "Mrs.", value: "mrs" },
        { text: "Ms.", value: "ms" },
        { text: "Dr.", value: "dr" },
      ],
      phoneRule: {
        regex:
          /^\+?\d{1,4}?[ -]?\(?\d{1,4}\)?[ -]?\d{1,4}[ -]?\d{1,4}[ -]?\d{1,9}$/,
        required: true,
        max: 18,
        min: 14,
      },
    };
  },
  components: {
    FormWizard,
    TabContent,
    VueSimpleSuggest,
    "v-select": vSelect,
    cInput,
    UploadPicture,
    cTelInput,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    Validator,
  },
  computed: {
    getCustomerTemplate() {
      return this.$store.getters["customer/getClientsTemplate"];
    },
    generatedBillDayValues() {
      return Array.from({ length: 30 }, (_, index) => index + 1);
    },
    generatedFiscalYearValues() {
      return Array.from({ length: 12 }, (_, index) => index + 1);
    },
    generatedFiscalQuaterValues() {
      return Array.from({ length: 3 }, (_, index) => index + 1);
    },
    cityTemplates() {
      return this.$store.getters["entity/getCityTemplate"];
    },
    ...mapState({
      locList: (state) => state.entity.locationList,
      cityTemplateData: (state) => state.entity.cityTemplate,
      resourceId: (state) => state.customer.customerResourceId,
      entityList: (state) => state.customer.entityList,
      fiscalYears: (state) => state.customer.fiscalYears,
      fiscalQuarters: (state) => state.customer.fiscalQuarters,
      parentClients: (state) => state.customer.parentClients,
    }),
  },
  methods: {
    testMethod3() {
      let temp = this.parentObj;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.parentObj = temp.id + " -- " + temp.displayName;
          this.customer.parentId = temp.id;
          this.customer.customerParentId = temp.id;
        }
      }
    },
    async imageSelected(fileData) {
      const data = fileData;
      this.imageData = data;
      try {
        let formData = new FormData();
        formData.append("clientId", this.resourceId);
        formData.append("file", this.imageData);
        setHeader("Content-Type", "multipart/form-data");
        let payload = {
          clientId: this.resourceId,
          formData: formData,
        };
        await this.$store.dispatch("customer/uploadProfilePicture", payload);
        removeHeader("Content-Type");
        this.imageData = {};
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async validate(index) {
      switch (index) {
        case 0: {
          const isValid = await this.$refs.observer1.validate();
          if (!isValid) return;

          this.nextTab();
          break;
        }
        case 1: {
          const isValid = await this.$refs.observer2.validate();
          if (!isValid) return;

          this.nextTab();
          break;
        }
        case 2: {
          const isValid = await this.$refs.observer3.validate();
          if (!isValid) return;

          this.formSubmitted();

          break;
        }
        // case 3: {
        //   const isValid = await this.$refs.observer4.validate();
        //   if (!isValid) return;

        //   this.formSubmitted();

        //   break;
        // }
      }
    },
    async formSubmitted() {
      const primaryAddress = {
        addressNo: this.customer.primary.address,
        city: this.customer.primary.city,
        state: this.customer.primary.state,
        country: this.customer.primary.country,
        district: this.customer.primary.district,
        zipCode: this.customer.primary.zipCode,
        addressType: "PRIMARY",
      };
      const billingAddress = {
        addressNo: this.customer.billing.address,
        city: this.customer.billing.city,
        state: this.customer.billing.state,
        country: this.customer.billing.country,
        district: this.customer.billing.district,
        zipCode: this.customer.billing.zipCode,
        addressType: "BILLING",
      };
      const addressArray = [primaryAddress, billingAddress];
      const clientData = {
        entryType: "IND",
        clientCategory: this.customer.categeory,
        officeId: this.customer.entity,
        title: this.customer.title,
        lastname: this.customer.lastName,
        phone: this.customer.phone,
        email: this.customer.email,
        idKey: this.customer.idProof,
        firstname: this.customer.firstName,
        middlename: this.customer.middleName,
        homePhoneNumber: this.customer.homePhone,
        billMode: this.customer.preferences,
        idValue: this.customer.idProofValue,
        locale: "en",
        active: true,
        dateFormat: "dd MMMM yyyy",
        activationDate: this.customer.activationDate,
        flag: false,
        externalId: this.customer.CafId,
        parentId:
          (this.customer.parentCheckBox ? 0 : this.customer.customerParentId) ||
          0,
        parentPoId: null,
        address: addressArray,
        gender: this.customer.gender,
        nationalityId: this.customer.nationalityId,
        vipId: this.customer.vipId,
        disabilityId: this.customer.disabilityId,
        businessName: this.customer.businessName,
        dateOfBirth: moment(this.customer.dateOfBirth).format("DD MMMM YYYY"),
        type: this.customer.billInfo.type,
        fiscalYear: this.customer.billInfo.fiscalYear,
        fiscalQuarter: this.customer.billInfo.fiscalQuater,
        billModes: this.customer.billInfo.billMode,
        invoiceType: this.customer.billInfo.invoiceType,
        billSuppressionFlag: this.customer.billInfo ? "Y" : "N",
      };
      // let paymentPayload = {
      //   data: null,
      //   clientId: "",
      // };
      // if (this.paymentType === "funder") {
      //   paymentPayload.data = {
      //     type: "Funder",
      //     funderName: this.customer.payInfo.funderName,
      //     funderAddress: this.customer.payInfo.address,
      //     paymentType: this.paymentType,
      //     paymentTerm: this.customer.payInfo.paymentTerm,
      //     funderId: this.customer.payInfo.funderId,
      //     poNumber: this.customer.payInfo.poNumber,
      //     name: this.customer.payInfo.funderName,
      //   };
      // } else if (this.paymentType === "credit card") {
      //   paymentPayload.data = {
      //     type: "CreditCard",
      //     cardNumber: this.customer.payInfo.cardNumber,
      //     cardExpiryDate: this.customer.payInfo.cardExpiryDate,
      //     cardType: this.customer.payInfo.cardType,
      //     cvvNumber: this.customer.payInfo.cvvNumber,
      //     name: this.customer.payInfo.cardHolderName,
      //   };
      // } else if (this.paymentType === "bank") {
      //   paymentPayload.data = {
      //     type: "Bank",
      //     routingNumber: this.customer.payInfo.cardRoutingNumber,
      //     bankAccountNumber: this.customer.payInfo.bankAccountNumber,
      //     bankName: this.customer.payInfo.bankName,
      //     accountType: this.customer.payInfo.accountType,
      //     name: this.customer.payInfo.accountHolderName,
      //   };
      // }
      this.customer.clientData = clientData;
      try {
        await this.$store.dispatch(
          "customer/createCustomerAction",
          this.customer.clientData
        );
        // paymentPayload.clientId = this.resourceId;
        // await this.$store.dispatch(
        //   "customer/paymentTypeAction",
        //   paymentPayload
        // );
        this.imageSelected(this.imageData);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Customer Created Succesfully!",
          type: "success",
          timer: 2000,
        });
        this.nextTab();
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    // resetPaymentTypeData() {
    //   this.payInfo = {
    //     funderName: "",
    //     address: "",
    //     funderId: "",
    //     poNumber: "",
    //     paymentTerm: null,
    //     cardHolderName: null,
    //     cardNumber: null,
    //     cardType: null,
    //     cardExpiryDate: null,
    //     cvvNumber: null,
    //     accountHolderName: null,
    //     bankAccountNumber: null,
    //     bankName: null,
    //     accountType: null,
    //     cardRoutingNumber: null,
    //   };
    // },
    async getTemplate() {
      try {
        await this.$store.dispatch("customer/setClientTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async parentSuggestionList() {
      try {
        await this.$store.dispatch("customer/setParentClients", this.parentObj);
        return this.parentClients;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async primaryCityTemplate() {
      try {
        await this.$store.dispatch(
          "entity/setCityTemplate",
          this.customer.primary.city
        );

        this.customer.primary.district = this.cityTemplateData.district;
        this.customer.primary.state = this.cityTemplateData.state;
        this.customer.primary.country = this.cityTemplateData.country;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async billingCityTemplate() {
      try {
        await this.$store.dispatch(
          "entity/setCityTemplate",
          this.customer.billing.city
        );

        this.customer.billing.district = this.cityTemplateData.district;
        this.customer.billing.state = this.cityTemplateData.state;
        this.customer.billing.country = this.cityTemplateData.country;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async officeTemplate() {
      try {
        await this.$store.dispatch("customer/setOptionsTemplate");
        this.customer.entityList = this.entityList;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    checkSameAddress() {
      if (this.sameAddress) {
        this.customer.billing.address = this.customer.primary.address;
        this.customer.billing.city = this.customer.primary.city;
        this.customer.billing.district = this.customer.primary.district;
        this.customer.billing.country = this.customer.primary.country;
        this.customer.billing.state = this.customer.primary.state;
        this.customer.billing.village = this.customer.primary.village;
        this.customer.billing.zipCode = this.customer.primary.zipCode;
      }
    },
    nextTab() {
      this.tabIndex = this.$refs.wizard.activeTabIndex + 1;
      this.$refs.wizard.nextTab();
    },
    handlerCityPrimaryChange() {
      this.primaryCityTemplate();
    },
    handlerCityBillingChange() {
      this.billingCityTemplate();
    },
    radioChange() {
      if (this.customer.radio == "corporate") {
        this.customer.showCorporate = true;
      } else {
        this.customer.showCorporate = false;
      }
    },
  },
  watch: {},
  mounted() {
    this.$store.dispatch("customer/clearResourceId");
    this.getTemplate();
    this.officeTemplate();
    this.$store.dispatch("customer/setFiscalYears");
    this.$store.dispatch("customer/setFiscalQuarters");
    Validator.extend("min_age", {
      validate(value) {
        const today = new Date();
        const birthDate = new Date(value);
        const age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        if (
          month < 0 ||
          (month === 0 && today.getDate() < birthDate.getDate())
        ) {
          return age > 18;
        }
        return age >= 18;
      },
      getMessage(field) {
        if (field == "date of birth") {
          return `You must be at least 18 years old.`;
        }
      },
    });
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";

.disabled-upload {
  display: none !important;
}
.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  width: 44%;
  left: 45px;
}
.min-w-100 {
  min-width: 115px;
}
.custom-select-title .vs__actions {
  padding: 4px 0px 0px 0px !important;
}
.custom-select-title .vs__dropdown-toggle .vs__search {
  margin: 0 !important;
  padding: 0 0 0 1px !important;
}
</style>
